document.addEventListener('ShoptetDOMPageContentLoaded', function() {
    customProduct()
});
document.addEventListener('ShoptetPageSortingChanged', function() {
    customProduct();
});
document.addEventListener('ShoptetDOMPageMoreProductsLoaded', function() {
    customProduct();
});
$(document).ready(function(){
    customProduct();
})

function customProduct() {
  if($('.product').length){
    var apiUrl = "https://friends.shopcode.cz/api-variantImagese.php";
    var section = "earmy";
    var productsCodes = [];
    $('.product').each(function() {
        var sku = $(this).find('span[data-micro="sku"]').text().trim();
        if (sku) {
            productsCodes.push(sku);
        }
        var minValue = $(this).find('.p-tools form input[name="amount"]').attr('value')
        var quantity = '<span class="quantity">'+
                        ' <label><input type="number" name="amount" value="1" class="amount" autocomplete="off" data-decimals="0" step="'+minValue+'" min="'+minValue+'" max="9999" aria-label="Množství" data-testid="cartAmount"></label>'+
                        '<button class="increase" aria-label="Zvýšit množství" tabindex="0" role="button" data-testid="increase"></button>'+
                        '<button class="decrease" aria-label="Snížit množství" tabindex="0" role="button" data-testid="decrease"></button>'+
                    '</span>'
        $(this).find('.p-code').addClass('loaded')
        if(!$(this).find('a.image .p-code').length){
            $(this).find('a.image').append($(this).find('.p-code'))
        }
        if(!$(this).find('.ratings-wrapper .p-code').length){
            $(this).find('.ratings-wrapper').append($(this).find('.p-code').clone())
        }
       

        if ($(this).find('.price-standard').length) {
            $(this).find('.prices').addClass('superPrice').prepend($(this).find('.price-standard'));
        }
        if($(this).find('.add-to-cart-button').length>0){
            if(!$(this).find('.quantity').length){
                $(this).find('.add-to-cart-button').before(quantity)
            }
            
        }
    });
    $.ajax({
        url: apiUrl,
        type: "GET",
        data: {
          section: section,
          codes: productsCodes.join(",")
        },
        dataType: "json",
        success: function(response) {
       
          $.each(response, function(index, group) {
            if ((!group.related || group.related.length === 0) ) {
              return;
            }
            var $productEl = $('.products-block .product').filter(function() {
              return $(this).find('a.image span[data-micro="sku"]').first().text().trim() === group.code;
            });
            if ($productEl.length) {
              $productEl.addClass('product-has-friend');
              var addFriend = '';
              var totalFriends = group.related.length;
              var maxVisible = window.innerWidth >= 1440 ? 4 : 3;
              if (totalFriends === maxVisible + 1) {
                maxVisible = totalFriends;
              }
              for (var i = 0; i < Math.min(totalFriends, maxVisible); i++) {
                var color = group.related[i];
                addFriend += "<li><a href='" + color.url + "'>" +
                             "<img src='" + color.image + "' alt='" + color.name + "' /></a></li>";
              }
              if (totalFriends > maxVisible) {
                var hiddenCount = totalFriends - maxVisible;
                addFriend += "<li class='more-friends'>+ " + hiddenCount + "</li>";
              }
            
              if (!$productEl.find('.productFriends').length) {
                $productEl.find('.image').append(
                  '<div class="productFriends">' +
                    '<ul>' + addFriend + '</ul>' +
                  '</div>'
                );
              }
            }
          });
        },
        error: function(xhr, status, error) {
          console.error("Chyba při volání API:", error);
        }
        });
  }
    
}